import { imageUrl } from '@helpers/image';
import { Device, from } from '@helpers/media';
import React from 'react';
import S from './CategoryChildPageCard.styles';
const CategoryChildPageCard = ({ content, cta, image, title, theme = 'default', }) => {
    const arDesktop = 267 / 526;
    const arMobile = 96 / 164;
    return (React.createElement(S.Container, { "data-theme": theme },
        React.createElement(S.Link, { href: cta.url, target: cta.target },
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement("picture", null,
                    React.createElement("source", { media: from(Device.Tablet), sizes: "50vw", srcSet: [
                            `${imageUrl(image, { width: 170, heightratio: arDesktop })} 170w`,
                            `${imageUrl(image, { width: 200, heightratio: arDesktop })} 200w`,
                            `${imageUrl(image, { width: 375, heightratio: arDesktop })} 375w`,
                            `${imageUrl(image, { width: 480, heightratio: arDesktop })} 480w`,
                            `${imageUrl(image, { width: 640, heightratio: arDesktop })} 640w`,
                            `${imageUrl(image, { width: 800, heightratio: arDesktop })} 800w`,
                        ].join(', ') }),
                    React.createElement(S.Image, { alt: image?.altText, draggable: false, loading: "lazy", role: "presentation", sizes: "50vw", src: imageUrl(image, { width: 170, heightratio: arMobile }), srcSet: [
                            `${imageUrl(image, { width: 170, heightratio: arMobile })} 170w`,
                            `${imageUrl(image, { width: 200, heightratio: arMobile })} 200w`,
                            `${imageUrl(image, { width: 375, heightratio: arMobile })} 375w`,
                            `${imageUrl(image, { width: 480, heightratio: arMobile })} 480w`,
                            `${imageUrl(image, { width: 640, heightratio: arMobile })} 640w`,
                            `${imageUrl(image, { width: 800, heightratio: arMobile })} 800w`,
                        ].join(', ') })))),
            React.createElement(S.ContentWrapper, null,
                React.createElement(S.Title, null, title),
                content && React.createElement(S.Content, null, content),
                React.createElement(S.Cta, null,
                    cta.text,
                    " ",
                    React.createElement(S.Chevron, null))))));
};
export default CategoryChildPageCard;
